module.exports = __webpack_public_path__ + "img/ExecutiveSearch.7c78c57a.jpg";